import { render, staticRenderFns } from "./SubscriptionsOverviewCard.vue?vue&type=template&id=10c4a418&scoped=true&"
import script from "./SubscriptionsOverviewCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4a418",
  null
  
)

export default component.exports